import i18n from '@/i18n';

export enum DocumentCategory {
  DeclarationOfCoOwnership = 'declaration_of_coownership',
  Regulations = 'regulations',
  CadastreAndCertificateOfLocation = 'cadastre_and_certificate_of_location',
  PlansAndPermits = 'plans_and_permits',
  ReferenceUnit = 'reference_unit',
  Transcript = 'transcript',
  BudgetAndFinancialStatements = 'budget_and_financial_statements',
  Contracts = 'contracts',
  StudyOfTheContingencyFundAndMaintenanceLog = 'study_of_the_contingency_fund_and_maintenance_log',
  Insurance = 'insurance',
  EvacuationPlan = 'evacuation_plan',
  ReportsAndExpertise = 'reports_and_expertise',
  Works = 'works',
  Assemblies = 'assemblies',
  BoardOfDirectors = 'board_of_directors',
  Other = 'other'
}

export class DocumentCategoryHelper {
  static values(): string[] {
    return Object.keys(DocumentCategory).filter((item) => isNaN(Number(item)))
  }

  static categoriesLabelAndSlug(): any[] {
    return this.values().map((documentCategory: string) => {
      return {
        label: i18n.t(`document.categories.${documentCategory.makeFirstLetterLowercase()}.name`),
        slug: i18n.t(`document.categories.${documentCategory.makeFirstLetterLowercase()}.slug`)
      }
    });
  }

  static categoriesNameAndLabel(): any[] {
    return this.values().map((documentCategory: string) => {
      return {
        name: this.getCategoryValueOfKey(documentCategory),
        label: i18n.t(`document.categories.${documentCategory.makeFirstLetterLowercase()}.name`)
      }
    });
  }

  static getCategoryNameFromSlug(categorySlug: string) {
    const dict: any = {}
    Object.keys((i18n.messages[i18n.getLocale()]['document']['categories'])).forEach((x: any) => {
      dict[i18n.messages[i18n.getLocale()]['document']['categories'][x]['slug']] = x
    })
    return dict[categorySlug]
  }

  static getCategoryValueOfKey(key: string) {
    // eslint-disable-next-line
    return Object.entries(DocumentCategory).find(([k, _]) => k.toUpperCase() === key.toUpperCase())?.[1]
  }
}